<div class="bg">
  <div class="page">
    <div class="content">
      <h1>Payment Voucher</h1>
      <div fxLayout="row">
        <p><strong>Paid To:</strong></p>
        <div fxFlex>
          <div class="box">
            <p>{{Supplier}}</p>
            <p>{{SupplierAddress}}</p>
            <p>{{SupplierCity}}</p>
          </div>
        </div>
        <div fxLayout="column">
          <p>{{company_name}}</p>
          <p><strong>Voucher No :</strong> {{VoucherNo}}</p>
          <p><strong>Date :</strong> {{date}}</p>
        </div>
      </div>
      <div fxLayout="row">
        <div class="borderBox">
          <p><strong>Payment Mode</strong></p>
        </div>
        <div fxFlex class="borderBox">
          <p>{{paidMode}}</p>
        </div>
      </div>
      <br>
      <div fxLayout="row">
        <div fxFlex="75" class="borderBox" style="height: 80px;">
          <p><strong>Amount in words:</strong></p>
          <p>{{amountInWords}}</p>
        </div>
        <div fxFlex="25" class="borderBox" style="height: 80px;">
          <p><strong>Amount (LKR):</strong></p>
          <p>{{amount|currency: ' '}}</p>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex class="borderBox">
          <p><strong>Being Payment for </strong>{{grnNos}}</p>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex class="borderBox">
          <p><strong>Remarks</strong></p>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex class="borderBox" style="height: 50px;">
          <p>{{Description}}</p>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex="33.33" class="borderBox" style="height: 80px;">
          <p><strong>Prepared:</strong> {{username}}</p>
          <p>………..…/............../………..…</p>
        </div>
        <div fxFlex="33.33" class="borderBox" style="height: 80px;">
          <p><strong>Checked:</strong></p>
          <p>………..…/............../………..…</p>
        </div>
        <div fxFlex="33.33" class="borderBox" style="height: 80px;">
          <p><strong>Authorized:</strong></p>
          <p>………..…/............../………..…</p>
        </div>
      </div>
      <br>
      <div fxLayout="row">
        <div fxFlex="75" class="borderBox" style="height: 190px;">
          <p><strong>Receipt:</strong></p>
          <p>Received the above sum with thanks, from {{company_name}}</p>
          <div fxLayout="row">
            <div fxFlex>
              <p>……………………………………….. </p>
              <p>Signature</p>
              <p>NIC No:</p>
            </div>
            <div FxFlex>
              <p><strong>Name:</strong> ………………………………………………………………….......</p>
              <p><strong>Date:</strong> {{date}}</p>
            </div>
          </div>
        </div>
        <div fxFlex="25" class="borderBox" style="height: 190px;">

        </div>
      </div>

    </div>
  </div>

  <button mat-fab class="fabPrint" color="warn" (click)="print()">
    <mat-icon>print</mat-icon>
  </button>

</div>